module.exports = __webpack_public_path__ + "img/planet-logo.be4b29d9.svg";